'use client';

import getLocationName from '@alltrails/core/utils/getLocationName';
import usePrintElevation from '@alltrails/print/hooks/usePrintElevation';
import usePrintRoute from '@alltrails/print/hooks/usePrintRoute';
import { useAppSelector } from '@/utils/redux';

const useRoutePrintFields = () => {
  const { bounds } = usePrintRoute();
  const { elevationData, elevationGain, elevationLoss } = usePrintElevation();
  const { routeId, routeLocation, slug } = useAppSelector(state => ({
    routeId: state.customRoute?.route.id,
    routeLocation: state.customRoute?.map?.location ?? state.customRoute?.route.location,
    slug: state.customRoute?.route.slug
  }));

  return { bounds, elevationData, elevationGain, elevationLoss, location: getLocationName(routeLocation), routeId, slug };
};

export default useRoutePrintFields;
